import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';
import type { FailureReason } from '@Application/Security/TokenJourney/FailureReason';

/**
 * This route answers `400` (invalid address, field errors present) or `429` (rate limit exceeded,
 * no field errors — the delay travels in `message`). `resolveFailureReason` only distinguishes
 * `404`/`410`/`400`, so `reason` is `invalid` on `400` and `unknown` on every other status, `429`
 * included; the caller reads `message` for the full picture on `unknown`.
 */
export type PasswordResetRequestFailedAction = {
	type: 'PASSWORD_RESET_LINK_REQUEST_FAILED';
	payload: ExtractedMessages;
	reason: FailureReason;
	message: string;
};

export default (
	payload: ExtractedMessages,
	reason: FailureReason,
	message: string,
): PasswordResetRequestFailedAction => ({
	type: 'PASSWORD_RESET_LINK_REQUEST_FAILED',
	payload,
	reason,
	message,
});
